<template>
    <div>
        <el-dialog class="lnk-mvg"
                   :close-on-click-modal="false"
                   :visible.sync="showMvg"
                   :title="mvgTitle"
                   width="900"
                   append-to-body
                   @close="closeDlg">
            <el-row v-loading="loading">
                <el-col :span="12" class="link-mvg-left">
                    <lnk-simple-table v-model="leftSelectedList"
                                      ref="leftTable"
									  :http-instance="httpInstance"
                                      :key="`left_${tableKey}`"
									  :row-height="rowHeight"
									  :header-height="headerHeight"
									  :show-page-num="false"
									  :pageSizes="fitRows"
                                      :multi-select="leftGridOptions.multiSelect"
                                      :url="leftGridOptions.url"
                                      :page-flag="leftGridOptions.pageFlag"
                                      :total-flag="leftGridOptions.totalFlag"
                                      :params="leftQueryParams"
                                      :fields="leftGridOptions.fields"
                                      :return-original-data="true"
									  :oauth="leftOauth ? leftOauth : oauth"
									  :show-pager="true"
                                      @update-list="updateLeftDataList"/>
                </el-col>

                <el-col :span="12" class="link-mvg-right">
                    <lnk-simple-table v-model="rightSelectedList"
                                      ref="rightTable"
									  :http-instance="httpInstance"
                                      :key="`right_${tableKey}`"
									  :row-height="rowHeight"
									  :header-height="headerHeight"
									  :show-page-num="false"
									  :pageSizes="fitRows"
                                      :multi-select="rightGridOptions.multiSelect"
                                      :url="rightGridOptions.url"
                                      :page-flag="rightGridOptions.pageFlag"
                                      :total-flag="rightGridOptions.totalFlag"
                                      :params="rightQueryParams"
                                      :fields="rightGridOptions.fields"
									  :oauth="oauth || rightOauth || 'ALL'"
                                      :return-original-data="true"
									  :show-pager="true"
                                      @update-list="updateRightDataList">
                        <template slot="append">
                            <el-table-column label="是否主要" :min-width="80" v-if="requireDefaultRow">
                                <template slot-scope="scope">
                                    <el-button v-show="(scope.row.isDefault === 'Y' || (customDefaultId && customDefaultId === scope.row.id))" size="mini" type="text"
                                               style="color:#F00">
                                        主要记录
                                    </el-button>
                                    <div></div>
                                    <el-button v-if="!inputMvgDisabled" v-show="!(scope.row.isDefault === 'Y' || (customDefaultId && customDefaultId === scope.row.id))" type="text" size="mini"
                                               @click.stop="setDefaultItem(scope.row, scope.$index)">设为主要
                                    </el-button>
                                </template>
                            </el-table-column>
                        </template>
                    </lnk-simple-table>
                </el-col>

                <!-- 中间左右移动工具栏 -->
                <div class="link-mvg-center">
                    <el-button size="mini"  type="text" :disabled="inputMvgDisabled || leftDataList.length ===0" @click="moveToRight">
						<link-icon class="notonhover" icon="link-icon-you"></link-icon>
						<link-icon class="onhover" icon="link-icon-youtianchong"></link-icon>
                    </el-button>
                    <el-button size="mini" type="text"  :disabled="inputMvgDisabled || rightDataList.length ===0" @click="moveToLeft">
						<link-icon class="notonhover" icon="link-icon-zuo"></link-icon>
						<link-icon class="onhover" icon="link-icon-zuotianchong"></link-icon>
                    </el-button>
                    <el-button size="mini"  type="text"  :disabled="inputMvgDisabled || rightDataList.length ===0" @click="moveAllToLeft">
						<link-icon class="notonhover" icon="link-icon-quanbuwangzuo"></link-icon>
						<link-icon class="onhover" icon="link-icon-quanbuwangzuotianchong"></link-icon>
                    </el-button>
                </div>

                <!--<el-button size="mini" type="primary" @click="confirmButton">{{$t('global.confirm')}}</el-button>
                <el-button size="mini" type="primary" @click="cancelChange">还原</el-button>-->
            </el-row>
            <!-- 弹出框确定与取消按钮 -->
            <span slot="footer" class="dialog-footer">
            <el-row style="margin: 0;">
                <el-col :span="24" align="center">
                    <link-button type="line" @click="cancelChange">{{$t('global.cancel')}}</link-button>
                    <link-button :disabled="inputMvgDisabled" @click="confirmChange">{{$t('global.confirm')}}</link-button>
                </el-col>
            </el-row>
            </span>
        </el-dialog>

        <el-input v-if="mvgType===MvgTypeEnum.INPUT" v-model="inputVal"
                  :size="size"
                  :disabled="inputMvgDisabled"
                  readonly>
			<link-icon
				slot="suffix"
				style="cursor: pointer;margin-right:5.5px"
				icon="link-icon-mvg"
				@click="showInputMvg= !showInputMvg"></link-icon>
            <!--<i class="el-input__icon icon iconfont icon-mvg"
               style="cursor: pointer;display: inline-block"
               slot="suffix"
               @click="showInputMvg= inputMvgDisabled ? showInputMvg: true"> &lt;!&ndash; 禁用情况下禁止打开mvg &ndash;&gt;
            </i>-->
        </el-input>
    </div>
</template>

<script>
    /* eslint-disable key-spacing */
    import lnkSimpleTable from '../lnk-simple-table';
    import {getFitRows} from "../lnk-picklist";
    import LinkIcon from "../../link-components/icon/link-icon";
    import deepmerge from 'deepmerge';

    export default {
        name: 'lnk-mvg',
        components: {LinkIcon, lnkSimpleTable},
      	inject: { // 获取父组件的provide
			elForm: {default: ''},
			elFormItem: {default: ''}
	  	},
      	props: {
          	leftParams: {
          	  type: Object,
			  default(){
			    return {}
			  }
			},
          	rightParams: {
          	  type: Object,
			  default(){
			    return {}
			  }
			},
			// 单独指定使用的http实例，不指定则按默认规则
			httpInstance: Object,
			show: {
			  type: Boolean,
			  default: false
			},
			mvgService: { // mvg指向的服务平台
			  type: String,
			  default: 'action'
			},
			requireDefaultRow: { // 需要设置默认记录，否则第一条为默认记录
			  type: Boolean,
			  default: true
			},
			mvgName: { // mvg名称--必填
			  type: String,
			  required: true
			},
			mvgParentId: { // mvg父记录id--必填
			  type: String,
			  required: true,
			  default:''
			},
			autoSave: { // 是否由组件来保存变动的数据
			  type: Boolean,
			  default: true
			},
			title: String,
			leftTableOptions: { // 列表列配置参数，与列表组件配置参数fields一致，若mvg左右列表列一致则只需要配置此参数即可，无需配置leftFieldsOptions及rightFieldsOptions
			  type: Object,
			  default(){
				return {};
			  }
			},
			rightTableOptions: { // 列表列配置参数，与列表组件配置参数fields一致，若mvg左右列表列一致则只需要配置此参数即可，无需配置leftFieldsOptions及rightFieldsOptions
			  type: Object,
			  default(){
				return {};
			  }

			  /* validator: function(obj){
					  return true;
				  }*/
			},
			// parentDefaultItem: Object,//父对象v-model传入的对象

			remote: String, // 加载远程配置链接

			disabled: Boolean, // mvg是否可用
			inputVal: [String, Object], // input类型时v-model绑定的值
			mvgType: String, // picklist展示形式，input表示用输入框
			mainField: String, // 主要记录的字段名称

			pickMap: Object, // 属性映射，key为mvg列表主要记录字段名称，value为返回字段名称
			pickObject: Object, // 由父组件传入带.sync修饰符参数，在mvg组件内自动修改该对象值，不用外层监听事件再进行修改
			size: {
			  type: String,
			  default: 'mini'
			},
			mvgItemPiper: {type: Function}, //用于处理新建/更新/删除接口的参数
			beforeCofirm: {type: Function},
			customDefault: String, // 自定义主要记录的id
			oauth: String, // 安全性
			/*列表行的高度*/
			rowHeight: {type: [String, Number], default: 32},
			/*列表头的高度*/
			headerHeight: {type: [String, Number], default: 32},
			leftOauth: String, // 左边安全性
			rightOauth: String, // 右边安全性
			autoRefresh: Boolean   // 是否自动刷新mvg右侧数据
      	},
      	model: {
        	prop: 'inputVal',
        	event: 'innerChange'
      	},
      	computed: {
			// 获取真正使用的http实例
			$$http() {
			  return this.httpInstance || this.$http;
			},
			mvgTitle(){
			  if(this.title){
				return this.title;
			  }else if(this.remoteConf.title){
				return this.remoteConf.title;
			  }else{
				return 'MVG';
			  }
			},

			/**
			 * 输入框mvg是否禁用
			 * @returns {*}
			 */
			inputMvgDisabled() {
			  return this.disabled || (this.elForm || {}).disabled; // 通过上层表单元素是否禁用来确定当前是否禁用
			},
			/**
			 * 自定右边表格的主要记录id
			 * @returns {*}
			 */
			customDefaultId(){
			  var result = '';
			  if(this.isCustomDefaultAvail){
				result = this.customDefault;
			  }
			  return result;
			}
      	},
	  	watch: {
			mvgParentId(){
		  		this.reInitData();
			},
			showInputMvg:{
			  immediate:true,
			  handler:function (val) {
				if(this.mvgType === this.MvgTypeEnum.INPUT){
				  this.showMvg = val;
				  if(val){
					  this.getQueryParams();
					  if(this.$refs.rightTable && this.autoRefresh){
					  	this.$refs.rightTable.setPageFirstAndQueryData();
					  }
					this.isCustomDefaultAvail = true;
					if(!this.requireDefaultRow && this.rightDataList.length){
					  this.setDefaultItem(this.rightDataList[0], 0);
					}else{
					  this.updateRightDataList(this.rightDataList);
					}
				  }
				}
			  }
			},
			show:{
			  immediate:true,
			  handler:function (val) {
				if(this.mvgType !== this.MvgTypeEnum.INPUT){
				  this.showMvg = val;
				  if(val){
				  	this.getQueryParams();
					this.isCustomDefaultAvail = true;
					(this.rightDataList != null && this.rightDataList.length > 0) && this.updateRightDataList(this.rightDataList)
				  }
				}
			  }
			}
	  	},
        data: function(){
            return {
                loading: false,
                showMvg:false, // 弹出框的显示
                showInputMvg: false, // 输入框形式打开mvg
                tableKey: Date.now(),
                fitRows:[10,20,30,40,50],
                MvgTypeEnum: {INPUT: 'input'},
                remoteConf: {
                    leftTableOptions: {},
                    rightTableOptions: {}
                }, // 远程配置
                leftGridOptions: {
                    multiSelect: true,
                    url: this.mvgService + `/${LinkVue.prefixUrl}/mvg/queryLeftListPage`,
                    // pageSizes: [15,30,50],
                    pageFlag: true,
                    totalFlag: false,
                    // fields: [],
                    params: {
                        mvgMapperName: this.mvgName,
                        mvgParentId: this.mvgParentId
                    }

                },
                rightGridOptions: {
                    multiSelect: true,
                    url: this.mvgService + `/${LinkVue.prefixUrl}/mvg/queryRightListPage`,
                    totalFlag: true,
                    pageFlag: false, // 不分页
                    pageLayout: 'sizes,pager,->,slot',
                    // fields: [ //显示列的配置],
                    params: {
                        mvgMapperName: this.mvgName,
                        mvgParentId: this.mvgParentId
                    }
                },

                isCustomDefaultAvail: false,

                leftDataList: [], // 左侧列表数据
                rightDataList: [], // 右侧列表数据
                defaultItem: {}, // 后台默认主要记录

                editDefaultItem: {}, // 编辑过程中默认的主要记录

                leftSelectedList: [], // 左侧列表已选中数据
                rightSelectedList: [], // 右侧列表已选中数据

                movedToRightList: [], // 从左边移到右边数据暂存区--右移暂存区
                movedToLeftList: [],// 从右边移到到左边数据暂存区--左移暂存区

				leftQueryParams: {}, //左边列表的查询参数
				rightQueryParams: {}, //右边列表的查询参数
            };
        },

        async created(){
            if(this.remote){
                try {
                    this.remoteConf = await this.$$http.post(this.remote,{});
                }catch (e) {}
            }
            this.init();
        },
		/*async mounted(){
			// 判断 $mvg是否每次都刷新 parent 实例
			console.log(this.$options.parent.$options.parent.$options.parent.$el)
		},*/
        methods: {

            init(){
                this.fitRows = getFitRows();

				if(this.leftTableOptions.params){
                    this.leftGridOptions.params = Object.assign(this.leftTableOptions.params, this.leftGridOptions.params);
                }
                if(this.remoteConf.leftTableOptions && this.remoteConf.leftTableOptions.params){
                    this.leftGridOptions.params = Object.assign(this.remoteConf.leftTableOptions.params, this.leftGridOptions.params);// 合并远程查询条件，优先级比父组件指定条件低
                }
                this.leftGridOptions = Object.assign(this.remoteConf.leftTableOptions, this.leftTableOptions, this.leftGridOptions); // 内层对象不能做合并，只能后来的覆盖前面的，所以queryParams单独合并能用

                this.rightGridOptions = Object.assign(this.remoteConf.rightTableOptions, this.rightTableOptions, this.rightGridOptions);
                if(!this.rightGridOptions.fields || this.rightGridOptions.fields.length ===0){
                    this.rightGridOptions.fields = this.leftGridOptions.fields; // 右侧列表如不指定列，则使用左侧列表
                }
                this.getQueryParams();
                this.tableKey = Date.now();
            },
			/**
			 * @method：getQueryParams
			 * @createdBy:黄健
			 * @date: 2020-11-28
			 * @params:：
			 * @description: 获取左右列表的查询参数
			 */
			getQueryParams(){
            	let leftQueryParams = Object.assign({}, this.leftGridOptions.params);
            	let rightQueryParams = Object.assign({}, this.rightGridOptions.params);
            	leftQueryParams = deepmerge(leftQueryParams, Object.assign({}, this.leftParams));
				rightQueryParams = deepmerge(rightQueryParams, Object.assign({}, this.rightParams));
				const keyParam = {
					mvgParentId: this.mvgParentId,
					mvgMapperName: this.mvgName
				};
				leftQueryParams = deepmerge(leftQueryParams, keyParam);
				rightQueryParams = deepmerge(rightQueryParams, keyParam);
				if(JSON.stringify(leftQueryParams) !== JSON.stringify(this.leftQueryParams)){
					this.leftQueryParams = leftQueryParams;
				}
				if(JSON.stringify(rightQueryParams) !== JSON.stringify(this.rightQueryParams)){
					this.rightQueryParams = rightQueryParams;
				}
			},

            /**
             * 设置默认主要记录
             * @param item
             * */
            setDefaultItem: function(item, index){
                this.isCustomDefaultAvail =false;
                // this.defaultItem.isDefault = 'N';
                this.editDefaultItem.isDefault='N';
                this.editDefaultItem = item;
                this.$set(this.editDefaultItem, 'isDefault', 'Y');
                for(let i=0; i<this.rightDataList.length; i++){
                    if(this.rightDataList[i].id !== this.editDefaultItem.id){
                        this.$set(this.rightDataList[i], 'isDefault', 'N');
                        // this.rightDataList[i].isDefault = 'N';
                    }
                }
            },

            /**
             * 获取左侧列表最新查询返回的数据
             * @param rows
             */
            updateLeftDataList: function(rows){
                this.leftDataList = rows;
                for(let i=0; i<this.movedToRightList.length; i++){
                    // 查询左侧列表后，在返回的结果中删除已经加入到右侧的记录（右移暂存区）
                    const movedToRightItem = this.movedToRightList[i];
                    for(let j=0; j<this.leftDataList.length; j++){
                        const leftDataItem = this.leftDataList[j];
                        if(movedToRightItem.id === leftDataItem.id){
                            this.leftDataList.splice(j, 1);
                            j--;
                        }
                    }
                }
                if(this.movedToLeftList.length){
                    // 在查询左侧列表后，在返回的结果中加上已加入左侧列表的记录（左移暂存区）
                    // this.leftDataList.unshift.apply(this.leftDataList, this.movedToLeftList);
                    this.leftDataList.unshift(...this.movedToLeftList);
                }
            },

            /**
             * 获取右侧列表最新返回数据
             * @param rows
             */
            updateRightDataList: function(rows){
                this.rightDataList = rows;

                /* if(this.defaultItem.id === undefined){
                        //初始化默认记录，记录最初默认记录
                        for(let i=0; i<rows.length; i++){
                            if(rows[i].isDefault === 'Y'){
                                this.defaultItem.id = rows[i].id;//暂时只用到id,不展示在页面，不用$set
                                this.editDefaultItem = rows[i];
                                break;
                            }
                        }
                    }*/
                for(let i=0; i<rows.length; i++){
                    const item = rows[i];
                    if(this.defaultItem.id === undefined){
                        if(rows[i].isDefault === 'Y'){
                            this.defaultItem.id = rows[i].id;// 暂时只用到id,不展示在页面，不用$set
                            this.editDefaultItem = rows[i];
                            break;
                        }
                    }else{
                        if(item.id === this.editDefaultItem.id){
                            item.isDefault = 'Y';// 设默认标记为Y，使得右侧只有一个默认
                        }else{
                            item.isDefault = 'N';// 设默认标记为N，使得右侧只有一个默认值
                        }
                    }

                }
                for(let i=0; i<this.movedToLeftList.length; i++){
                    // 查询左侧列表后，在返回的结果中删除已经加入到左侧的记录（左移暂存区）
                    const movedToLeftItem = this.movedToLeftList[i];
                    for(let j=0; j<this.rightDataList.length; j++){
                        const rightDataItem = this.rightDataList[j];

                        /* if(rightDataItem.id === this.editDefaultItem.id){
                                rightDataItem.isDefault = 'Y';//设默认标记为Y，使得右侧只有一个默认
                            }else{
                                rightDataItem.isDefault = 'N';//设默认标记为N，使得右侧只有一个默认值
                            }*/
                        if(movedToLeftItem.id === rightDataItem.id){
                            this.rightDataList.splice(j, 1);
                            j--;
                        }
                    }
                }
                if(this.movedToRightList.length){
                    // 在查询左侧列表后，在返回的结果中加上已加入右侧列表的记录（右移暂存区）
                    // this.rightDataList.unshift.apply(this.rightDataList, this.movedToRightList);
                    this.rightDataList.unshift(...this.movedToRightList);
                }
                // console.log(JSON.stringify(this.rightDataList));

                // 无需手动设置默认记录时，默认选右侧第一条记录为默认记录
                if(!this.requireDefaultRow && this.rightDataList.length){
                    this.setDefaultItem(this.rightDataList[0], 0);
                }
            },

            /**
             * 点击右移按钮,左 ==》 右
             */
            moveToRight: function(){
                let setFirstDefaultFlag = false;// 是否要把右侧第一条记录设为默认
                if(this.rightDataList.length === 0){
                    setFirstDefaultFlag = true;
                }
                for(let i=this.leftSelectedList.length-1; i>=0; i--){
                    // console.log('左==》右: '+i);
                    const leftSelectedItem = this.leftSelectedList[i]; // 要移到右边的项
                    let foundInMovedToLeftList = false;// 是否在movedToLeftList暂存区中找到数据
                    for(let j=0; j<this.movedToLeftList.length; j++){
                        // 判断要移到右边的记录是否原来就是从右边移过来的，如果是则在movedToLeftList中有该记录，此时则删掉movedToLeftList中对应记录，并把记录恢复到rightDataList中
                        // 如果原来记录就是在左边的，则把记录加入到movedToRightList中，并在leftDataList中移除改记录
                        const movedToLeftItem = this.movedToLeftList[j];// 已经从右边移到左边的项
                        if(leftSelectedItem.id === movedToLeftItem.id){
                            this.movedToLeftList.splice(j, 1);
                            // this.rightDataList
                            foundInMovedToLeftList = true;
                            break;
                        }
                    }
                    if(!foundInMovedToLeftList){
                        // 没找到，则原来记录就是在左边的，把记录加入到movedToRightList中，并在leftDataList中移除改记录
                        this.movedToRightList.push(linkTools.deepCopy(leftSelectedItem));// 加到右移暂存区
                    }
                    for(let j=0; j<this.leftDataList.length; j++){ // 在左侧列表查找并删除对应记录
                        const leftDataItem = this.leftDataList[j];
                        if(leftDataItem.id === leftSelectedItem.id){
                            this.leftDataList.splice(j, 1);// 在左侧列表删除原记录
                            // this.rightDataList.unshift(leftDataItem);//在右侧列表加上记录
                            break;
                        }
                    }

                    this.rightDataList.unshift(leftSelectedItem);// 在右侧列表加上记录
                }
                if(setFirstDefaultFlag && this.rightDataList.length >0){
                    this.setDefaultItem(this.rightDataList[0], 0);// 第一条设为默认
                }
                this.$nextTick(()=>{
					this.$refs.rightTable.$refs.pagination.freshInfo(this.movedToRightList.length);
				})
            },

            /**
             * 点击右移按钮, 右 ==》 左
             */
            moveToLeft: function(){
                for(let i=this.rightSelectedList.length -1; i>=0; i--){
                    // console.log('右==》左: '+i);
                    const rightSelectedItem = this.rightSelectedList[i]; // 要移到左边的项
                    let foundInMovedToRightList = false; // 是否在movedToRightList暂存区内找到数据
                    let movedDefaultToLeftFlag = false;// 表示此次左移是否把主要记录移到了左边
                    for(let j=0; j<this.movedToRightList.length; j++){
                        // 判断右移暂存区是否包含当前需要移到左边的数据，是则表示当前数据原本就在左边的，只是之前移到了右边，此时需要还原，即从右移暂存区删除此数据，并加入到左侧列表
                        const movedToRightItem = this.movedToRightList[j];
                        if(rightSelectedItem.id === movedToRightItem.id){
                            this.movedToRightList.splice(j, 1);// 从右移暂存区删除此数据
                            foundInMovedToRightList = true;// 表示在暂存区找到对应记录
                            break;
                        }
                    }
                    if(!foundInMovedToRightList){
                        // 若在右移暂存区找不到记录，则表示当前记录本来就在右边的，此时需要把记录加到左移暂存区，并在右侧列表删除
                        this.movedToLeftList.push(linkTools.deepCopy(rightSelectedItem));// 加到左移暂存区
                    }
                    for(let j=0; j<this.rightDataList.length; j++){ // 在右侧列表查找并删除对应记录
                        const rightDataItem = this.rightDataList[j];
                        if(rightDataItem.id === rightSelectedItem.id){
                            this.rightDataList.splice(j, 1);// 在右侧列表删除数据
                            // this.leftDataList.unshift(rightDataItem);
                            if(rightDataItem.isDefault === 'Y'){
                                movedDefaultToLeftFlag = true;// 表示此次左移把主要记录移到了左边，后面需要重新指定一条主要记录
                            }
                            break;
                        }
                    }
                    rightSelectedItem.isDefault = 'N';// 左移的项不再是默认记录
                    this.leftDataList.unshift(rightSelectedItem);
                    if(movedDefaultToLeftFlag){
                        // console.log('主要记录左移了');
                        if(this.rightDataList.length >0){
                            // console.log('左边还有数据');
                            this.setDefaultItem(this.rightDataList[0], 0);
                        }
                    }
                }
				this.$nextTick(()=>{
					if (this.movedToRightList.length) this.$refs.rightTable.$refs.pagination.freshInfo(this.movedToRightList.length);
				})
            },
            moveAllToLeft: function(){
                this.$refs.rightTable.$refs.mainTable.clearSelection();
                this.rightDataList.forEach((item) => {
                    this.$refs.rightTable.$refs.mainTable.toggleRowSelection(item);
                });
                this.moveToLeft();
            },

            /**
             * 确定，把改动保存到后台
             */
            async confirmChange() {
                var that = this;
                var changeObj = {
                    deleteItems: [], // 需要删除的项--左移项
                    insertItems: [], // 需要新建的项--右移项
                    defaultItem: this.editDefaultItem, // 默认项
                    changeDefaultFlag: false, // 是否需要重新设置默认项
                    deleteAllFlag: false, // 是否全部删除右边表数据
                    changeList: [] // 标准mvg更改接口可接收的参数list
                };
                var mvgList = [];

                // 需要从中间表中删除的数据
                for(let i=0; i<this.movedToLeftList.length; i++){
                    let mvgItem = {
                        defField: 'isDefault',
                        mvgMapperName: this.mvgName,
                        mvgParentId: this.mvgParentId,
                        mvgSubsetId: this.movedToLeftList[i].id,
                        row_status: 'DELETE'
                    };
					if(typeof this.mvgItemPiper === 'function'){
						try {
							mvgItem = await this.mvgItemPiper({mvgItem, row: this.movedToLeftList[i]}) || mvgItem;
						}catch (e){}
					}
                    changeObj.deleteItems.push(this.movedToLeftList[i]);
                    mvgList.push(mvgItem);
                }
                // 需要插入到中间表的数据
                for(let i=0; i<this.movedToRightList.length; i++){
                    let mvgItem = {
                        defField: 'isDefault',
                        mvgMapperName: this.mvgName,
                        mvgParentId: this.mvgParentId,
                        mvgSubsetId: this.movedToRightList[i].id,
                        row_status: 'NEW'
                    };
					if(typeof this.mvgItemPiper === 'function'){
						try {
							mvgItem = await this.mvgItemPiper({mvgItem, row: this.movedToRightList[i]}) || mvgItem;
						}catch (e){}
					}
                    changeObj.insertItems.push(this.movedToRightList[i]);
                    mvgList.push(mvgItem);
                }
                // mvg点击弹框确定前 增加钩子函数
				if (!!this.beforeCofirm) {
					mvgList =  await this.beforeCofirm(mvgList);
				}
                if(this.defaultItem.id !== this.editDefaultItem.id && this.requireDefaultRow){
                    // 需要重设默认记录
                    let mvgItem = {
                        defField: 'isDefault',
                        mvgMapperName: this.mvgName,
                        mvgParentId: this.mvgParentId,
                        mvgSubsetId: this.editDefaultItem.id,
                        row_status: 'DEFAULT'
                    };
					if(typeof this.mvgItemPiper === 'function'){
						try {
							mvgItem = await this.mvgItemPiper({mvgItem, row: this.editDefaultItem}) || mvgItem;
						}catch (e){}
					}
                    changeObj.changeDefaultFlag = true;
                    mvgList.push(mvgItem);
                }
                changeObj.changeList = mvgList;
                if(this.rightDataList.length === 0 && this.autoSave === true){
                    // 右侧列表无数据，表示deleteAll
                    changeObj.deleteAllFlag = true;
                    if(this.movedToLeftList.length > 0){
                        // 避免什么都没改却发出请求
                        this.loading = true;
                        this.$$http.axiosForm.post(this.mvgService + `/${LinkVue.prefixUrl}/mvg/deleteAll`, {
                            mvgMapperName: this.mvgName,
                            mvgParentId: this.mvgParentId
                        }).then(function({data}){
                            that.loading = false;
                            if(data.success){
                                // that.$message.success('保存成功');
                                that.saveChangeAndClose(changeObj);
                            }else{
                                that.$message.error('保存错误:'+data.result);
                            }
                        }).
                        catch(function(error){
                            that.loading = false;
                            console.log(error);
                            that.$message.error('保存错误，请联系管理员');
                        });
                    }else{
                        this.saveChangeAndClose(changeObj);
                    }
                }else if(this.autoSave === true){
                    if(mvgList.length>0){
                        that.loading = true;
                        this.$$http.post(this.mvgService + `/${LinkVue.prefixUrl}/mvg/mvgModify`, mvgList).then(function(data){
                            that.loading = false;
                            if(data.success){
                                // that.$message.success('保存成功');
                                that.saveChangeAndClose(changeObj);
                            }else{
                                that.$message.error('保存错误:'+data.result);
                            }
                        }).
                        catch(function(error){
                            that.loading = false;
                            console.log(error);
                            that.$message.error('保存错误，请联系管理员');
                        });
                    }else{
                        this.saveChangeAndClose(changeObj);
                    }
                }else{
                    // 是否由组件自动保存数据--设置为false则返回修改的数据由父级页面自己处理
                    // this.$emit('mvg-change', changeObj);
                    // that.reInitData();
                    this.saveChangeAndClose(changeObj);
                }
            },

            /**
             * 向父级返回修改的数据，重新查询数据并关闭弹窗
             * @param changeObj
             */
            saveChangeAndClose: function(changeObj){
                this.$emit('mvg-change', changeObj);
                if(changeObj.deleteAllFlag){
                    // this.inputVal = '';
                    // this.$emit('innerChange', this.inputVal);
                    this.$emit('innerChange', '');
                    this.$emit('mvg-default-change', {});// 返回默认记录

                    if(this.pickObject){
                        for(const key in this.pickMap){
                            this.$delete(this.pickObject, this.pickMap[key]);// 新增属性需要加入到vue监听，用set
                            // this.pickObject[this.pickMap[key]] = row[key];
                        }
                    }
                }else{
                    var defaultItem = linkTools.deepCopy(this.editDefaultItem);
                    if(this.mvgType === this.MvgTypeEnum.INPUT){
                        // this.inputVal = defaultItem[this.mainField];
                        var inputVal = defaultItem[this.mainField];
                        this.$emit('innerChange', inputVal);// 返回默认记录指定字段值
                    }else{
                        this.$emit('innerChange', defaultItem);
                    }
                    this.$emit('mvg-default-change', defaultItem);
                    if(this.pickObject){
                        for(const key in this.pickMap){
                            this.$set(this.pickObject, this.pickMap[key], defaultItem[key]);// 新增属性需要加入到vue监听，用set
                            // this.pickObject[this.pickMap[key]] = row[key];
                        }
                    }
                }

                this.reInitData();
                this.closeDlg();
            },

            /**
             * 取消按钮，重新查询数据并关闭弹出窗
             */
            cancelChange: function(){
                this.reInitData();
                this.closeDlg();
            },

            /**
             * 重新初始化，销毁暂存数据并重新查询
             */
            reInitData: function(){
                // leftDataList:[],//左侧列表数据
                // rightDataList: [],//右侧列表数据
                this.defaultItem = {};// 后台默认主要记录
                this.editDefaultItem = {};// 编辑过程中默认的主要记录
                // this.leftSelectedList = [],//左侧列表已选中数据
                // this.rightSelectedList = [],//右侧列表已选中数据
                this.movedToRightList = [];// 从左边移到右边数据暂存区--右移暂存区
                this.movedToLeftList = [];// 从右边移到到左边数据暂存区--左移暂存区

                /* if(this.$refs.leftTable){
                    this.$refs.leftTable.setPageFirstAndQueryData();
                }
                if(this.$refs.rightTable){
                    this.$refs.rightTable.setPageFirstAndQueryData();
                }*/

            },

            closeDlg: function(){
                if(this.mvgType === this.MvgTypeEnum.INPUT){
                    this.showInputMvg = false;
                }else{
                    this.$emit('update:show', false);// 同时更新父组件
                }
            }
        }
    };
</script>

<style lang="scss">
    .lnk-mvg{
        overflow: hidden;
        .el-dialog{
            width: 60vw;
            min-width: 1000px;
            margin-top: 50vh!important;
            transform: translateY(-50%);
        }
        .el-dialog__body{
            max-height: initial!important;
            padding: 12px 16px;
        }
        .link-mvg-left{
            padding-right: 20px;
        }
        .link-mvg-right{
            padding-left: 20px;
            .el-pagination{
                display: none;
            }
        }
        .lnk-simple-table {
			.el-table::before{
				visibility: visible;
			}
			.el-link-toolbar + .el-table-box{
				margin-top: 8px;
			}
            .lnk-pagination-v{
                border: 0!important;
                height: 28px!important;
                padding: 0!important;
                margin-top:8px;
            }
        }
        .link-mvg-center{
            position: absolute;
            top: calc(50% - 60px);
            left: calc(50% - 15px);
            .el-button+.el-button{
                margin-top: 16px;
            }
            .el-button{
                margin: 0!important;
				font-size: 26px;
				display:block;
				min-width: 30px;
                i{
                    font-size: 26px;
                }
                .onhover{
                    display: none;
                }
                .notonhover{
                    color: #caccd3 !important;
                    display: block;
                }
                &:hover{
                    .onhover{
                        display: block;
                    }
                    .notonhover{
                        display: none;
                    }
                }
            }
        }
    }
	@include themeify{
		.lnk-mvg .link-mvg-center .el-button:hover .onhover{
			color: pl-var(color-primary);
		}
	}
</style>
